// Auto-generated skeleton for Task

import { TaskType } from "./TaskType";
import { User } from "./User";
import { Team } from "./Team";

export const Task: Api.Task = {
  id: 0,
  hp_id: null,
  task_type_id: 0,
  task_type: TaskType,
  due_date: '',
  due_time: null,
  created_hp: '',
  user_id_created: 0,
  user_created: User,
  team_id_created: 0,
  team_created: Team,
  priority: 0,
  team_id_assigned: 0,
  team_assigned: Team,
  recurring_monthly: false,
  recurring_weekly: false,
  text: '',
  documents_count: 0,
  documents: [],
  buildings: [],
  units: [],
  persons: [],
  records: [],
  craftsman_tasks: [],
  created: null,
  updated: null,
};

